import { ProductType } from '../constants/productTypes';
import {
  ProductBuilderMachineContext,
  ProductBuilderMachineState,
} from '../types';

type TrackColourStatePostProcess = (
  productType: ProductType,
  context: ProductBuilderMachineContext,
  states: ProductBuilderMachineState[],
) => ProductBuilderMachineState[];

export const trackColourPostProcess: TrackColourStatePostProcess = (
  productType,
  context,
  states,
) => {
  const {
    custom: { track },
  } = context;

  const productTypesAllowed: ProductType[] = ['Curtain', 'Sheer Curtain'];
  if (!productType || !productTypesAllowed.includes(productType)) return states;

  return track === 'No Thanks:0'
    ? states.filter(state => state !== 'trackColour')
    : states;
};
